 <!--------
To do: 
Out of stock display
 ------>
<template>
  <div id="data-list-thumb-view" class="data-list-container">

    <vs-table id="product-step-1" ref="table" multiple v-model="selected" pagination :max-items="itemsPerPage" search :data="products">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center">

          <!-- ACTION - DROPDOWN -->
          <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">

            <div class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32">
              <span class="mr-2">Actions</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item @click.stop="deleteProduct">
                <span class="flex items-center">
                  <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Delete</span>
                </span>
              </vs-dropdown-item>

            </vs-dropdown-menu>
          </vs-dropdown>

          <!-- ADD NEW -->
          <div id="product-step-2" class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewData">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add New Product</span>
          </div>
        </div>

        <vs-popup 
        background-color="rgba(255,255,255,.6)" 
        :active.sync="outOfNumber" 
        button-close-hidden
        title="Opps!">
        <p>You have reached your limit to create product.</p>
       <p> Kindly proceed to add-on page to make another purchase.</p>
        <br/>
           <vs-button color="primary">Go Add-on</vs-button>
           <vs-button @click="outOfNumber = false" color="grey" class="ml-5">Cancel</vs-button>
        </vs-popup>


        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ products.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : products.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th>Image</vs-th>
        <vs-th sort-key="name">Name</vs-th>
        <vs-th sort-key="min_price">Price</vs-th>
        <vs-th sort-key="status">Status</vs-th>
        <vs-th>Action</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody class="body">
          <vs-tr class="body_list" :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td class="img-container">
             <img v-if="tr.image !== null" :src="tr.image.feature.Location" ref="product-image" class="product-img" />
             <img v-else src="@/assets/images/pages/default-product.png" ref="product-image" class="product-img" />
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.name }}</p>
            </vs-td>

            <vs-td>
               <span class="product-price" v-if="tr.min_price == tr.max_price">RM {{tr.min_price.toFixed(2)}}</span>
               <span class="product-price" v-else>RM {{tr.min_price.toFixed(2)}} - RM {{tr.max_price.toFixed(2)}}</span>
            </vs-td>

            <vs-td>
             <vs-switch class="product-status mb-2" color="primary" @click="updateStatus(tr.status, tr.id)" v-model="tr.status" :vs-value="tr.status">
                <span slot="on">Live</span>
                <span slot="off">Draft</span>
              </vs-switch>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon icon="EyeIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="viewProduct(tr)"/>
              <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" class="ml-2" @click="editProduct(tr)" />
              <!-- <feather-icon icon="Trash2Icon" svgClasses="w-5 h-5 hover:text-primary stroke-current" class="ml-2" @click="deleteProduct" /> -->
            </vs-td>

          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <v-tour v-if="products.length === 0" name="productPageTour" :steps="steps"></v-tour>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.min.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

const dialogs = {
  confirmDelete: (ids, callback) => {
    let text, title;

    if (ids.length > 1) {
      title = `Confirm Deletion of ${ids.length} products`
      text = `Are you sure you want to delete these ${ids.length} products?`
    } else {
      title = `Confirm Deletion`
      text = `Are you sure you want to delete this product?`
    }

    return {
      type: 'confirm',
      color: 'danger',
      title: title,
      text: text,
      accept: callback
    }
  },
  deleteWithForm: (ids, callback) => {
    let text, title;

    if (ids.length > 1) {
      title = `Confirm Deletion of ${ids.length} products`
      text = `The products that you wish to delete are linked with the form you created, perform deletion will also delete the form as well. Are you sure you want to delete these ${ids.length} products?`
    } else {
      title = `Confirm Deletion`
      text = `The product that you wish to delete are linked with the form you created, perform deletion will also delete the form as well. Are you sure you want to delete this product?`
    }

    return {
      type: 'confirm',
      color: 'danger',
      title: title,
      text: text,
      accept: callback
    }
  },
  expired: (error) => {
    return {
      color: "primary", 
      title: "Your current package is expired!",
      text: "Subscribe a new pakcage to unlock the dashboard summary.",
      accept:() => {
        router.push('/billing/current-plan')
      },
      close:() => {
        router.push('/billing/current-plan')
      }
    }
  }
}

export default {
  components: {
    swiper,
    swiperSlide
  },
  data () {
    return {
      selected: [],
      itemsPerPage: 4,
      isMounted: false,
      popup: false,
      outOfNumber: false,
      popupActivo5:false,
      cur: {},
      counter: 0,
      swiperOption: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },

      products: [],
      product: {},
      steps: [
        {
          target: '#product-step-1', 
          header: {
            title: 'Products Page',
          },
          content: `You’ll be able to manage your products at this page.`,
        },
        {
          target: '#product-step-2', 
          header: {
            title: 'Add Your First Product',
          },
          content: `Click on this button to add your first product!`,
        },
      ],
      product_in_form: []
    }
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    product_count () {
      let subs = this.$store.state.user.organizations.find(o => o.organization_id === this.$store.state.user.current_organization).subscription
      if(subs !== null){
        return subs.product_quota - this.products.length
      }else{
        this.$vs.dialog(dialogs.expired())
      }
    },
    acquireDropDownStatus () {
      if(this.product.variant.length === 0) {
        return 1
      } else if (this.product.variant[0].hasOwnProperty('option')){
        return 2
      } else {
        return 3
      }
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.products.length
    }
  },
  methods: {
    async updateStatus (status,id){
      let payload = {id,status:!status}
      this.$store.dispatch('product/updateProductStatus',payload)
      .then(() =>{
       this.$vs.notify({
        title: 'Success',
        text: 'Status updated Successful!',
        iconPack: 'feather',
        icon: 'icon-check',
        color: 'success'	
			  })
     })
    },
    getCheck (value) {
      if(this.cur.label !== value.label){
        this.cur = value
        this.counter = 1
      } else {
        this.counter++
      }
      return cur
    },
    addNewData () {
      if(this.product_count === 0){
        this.outOfNumber = true
      } else {
        this.$router.push({name: 'add-product'})
      }
    },
    editProduct (payload) {
      this.$router.push({name: 'edit-product', params: { product: payload}})
    },
    viewProduct (payload) {
      this.$store.dispatch('product/getProduct',payload).then((res) =>{
        this.$router.push({name: 'product-details', params: { product: res}})
      })
    },
    getStatusColor (status) {
      if (status === 1)   return 'success'
      if (status === 0) return 'dark'
    },
    getConditionStatusColor (status) {
      if (status === 1)   return 'success'
      if (status === 0) return 'danger'
    },
    getIsShippingStatusColor (status) {
      if (status === 1)   return 'text-success'
      if (status === 0) return 'text-danger'
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    },
    async deleteProduct() {
      let product_ids = this.selected.map(x => x.id)
      console.log(product_ids)
      if(this.product_in_form.some(f => product_ids.find(p => p === f))){
        this.$vs.dialog(dialogs.deleteWithForm(product_ids, () => {
          this.$store.dispatch('product/deleteProduct', product_ids)
          .then(() => location.reload())
          .catch(err => { console.error(err) })
        }));
      }else {
        this.$vs.dialog(dialogs.confirmDelete(product_ids, () => {
          this.$store.dispatch('product/deleteProduct', product_ids)
          .then(() => location.reload())
          .catch(err => { console.error(err) })
        }));
      }
      
    },
    productInForm(ids){
      return
    }
  },
  created () {
    this.$store.dispatch('product/getProducts').then(x => {
      this.products = JSON.parse(JSON.stringify(this.$store.state.product.products || []));
      this.product = JSON.parse(JSON.stringify(this.$store.state.product.product || {}));
    });
    this.$store.dispatch('form/refreshList').then(() => {
       this.$store.state.form.forms.forEach(f => {
        f.products.forEach(p => {
          this.product_in_form.push(p.product_id)
        })
      })
    })
  },
  mounted () {
    this.isMounted = true
    this.$tours['productPageTour'].start()
  }
}
</script>

<style lang="scss">
  .v-tour {
    .v-step {
        z-index: 52000;
        background-color: rgba(var(--vs-primary),1);
        border-radius: .5rem;
        padding: 1.5rem;
        filter: drop-shadow(0 0 7px rgba(0,0,0,.5));

        .v-step__arrow {
            border-color: rgba(var(--vs-primary),1);
        }

        .vs-button-border:not(.btn-tour-next):not(.btn-tour-finish) {
            border-color: rgba(255, 255, 255, .5) !important;
        }

        .v-step__header{
          background-color: #CE0668;
        }
    }
  }

.empty {
  display: grid;
  margin-top: 10rem;
  img {
    justify-self: center;
    align-self: center;
    width: 200px;
  }
}

.vs-tooltip {
  z-index: 62000;
}
#data-list-thumb-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;


      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 10px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
            &.img-container {
              width: 1rem;
              // height: 110px;
              background: #fff;
              overflow: hidden;

              span {
                display: flex;
                justify-content: flex-start;
              }

              .product-img {
                max-width: 150px;
                height: 110px;
                margin-left: auto;
                margin-right: auto;
              }
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}

#data-list-thumb-view .vs-con-table .product-name {
    max-width: 11rem;
}

.variant-popup {
  z-index: 63000;
}

.variant-table{
    tbody{
       border: 0.5px solid lightpink;
      tr {
        border: 0.5px solid lightpink;
        td {
          border: 0.5px solid lightpink;
        }
      }
    }
}

.popup-container{
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  place-items: center;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 53000;
  background:rgba(255,255,255,.6);
  height:100%;
  transition: all .25s ease;
  -webkit-transition: all .25s ease;
}

.container:last-of-type{
  display: none;
}

.card {
  min-height: 80vh;
  width: 35rem;
  border-radius: 30px;
  padding: 0rem 5rem;
  box-shadow: 0 20px 20px rgba(0, 0, 0, 0.2), 0px 0px 50px rgba(0, 0, 0, 0.2);
  background: white;
}

.product {
  min-height: 35vh;
  display: flex;
  align-items: center;
	justify-content: center;
}

.product-image {
  width: 15rem;
	// transform: translateX(20px); 
}

.cross-icon {
	 position:absolute;
   bottom:90px;
	 left: 90px;
}

.info h5{
  padding: 2rem 0rem;
  color: #585858;
  font-weight: lighter;
}

.variation{
  display: flex;
  justify-content: space-between;
}

.edit {
  margin-top: 2rem;
}

.edit button {
  width: 100%;
  padding: 1rem 0rem;
  background: #F9278E;
  border: none;
  color: white;
  cursor: pointer;
	border-radius: 30px;
}

@media screen and (max-width: 736px) {
  .vs-table--thead{
    display: none;
  }

  .body_list{
    display: grid;
    grid-template-areas:
    "checkbox" 
    "image"
    "name"
    "price"
    "status";
  }

  .td-check{
    grid-area: checkbox;
    display: flex;
  }

  .vs-table--td{
    align-self: center;
    justify-self: center;
  }

  .tr-values{
    grid-gap: 10px;
  }

  #data-list-thumb-view .vs-con-table .vs-table tr td.img-container {
    width: auto; 
  } 

  .product-img{
    grid-area: image;
  }

  .product-name{
    grid-area: name;
  }

  .product-price{
    grid-area: price;
  }

  .product-status{
    grid-area: status;
  }
}

</style>
